import { render, staticRenderFns } from "./UserManagerMessage.vue?vue&type=template&id=4b1b501a&scoped=true&"
import script from "./UserManagerMessage.vue?vue&type=script&lang=js&"
export * from "./UserManagerMessage.vue?vue&type=script&lang=js&"
import style0 from "./UserManagerMessage.vue?vue&type=style&index=0&id=4b1b501a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1b501a",
  null
  
)

export default component.exports